import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { LoyaltyWebsiteEffects } from './loyalty-website.effects';
import { ILoyaltyWebsiteFeature } from './loyalty-website.feature.state';
import { loyaltyWebsiteReducer } from './loyalty-website.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ILoyaltyWebsiteFeature>('loyaltyWebsiteFeature'), loyaltyWebsiteReducer),
    EffectsModule.forFeature([LoyaltyWebsiteEffects]),
  ],
})
export class LoyaltyWebsiteStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: LoyaltyWebsiteStateModule
  ) {
    if (parentModule) {
      throw new Error('LoyaltyWebsiteStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
